import * as React from 'react';

import type {QuoteDisplayStatus} from 'nutshell-graphql-types';
import type {GetQuotes_quotes as Quote} from 'nutshell-graphql-types';

import {getQuoteTimes} from '../../../../../../ui/lead/sales-documents/shared';

import {StackLegacy} from '../../layout/stack/stack-legacy';

import {getQuoteActionMenuOptions} from './helpers';
import {SalesDocumentRow} from './sales-document-row';

type Props = {
    quotes: Quote[];
    handleDownloadQuote: (slug: string) => void;
    handleUpdateQuoteStatus: (id: string, status: QuoteDisplayStatus) => void;
    handleDuplicateQuote: (id: string) => void;
    handleSendQuoteViaEmail: () => void;
    handleCreateInvoiceFromQuote: (id: string) => void;
};

export function QuotesSection(props: Props) {
    return (
        <StackLegacy spacing={16}>
            {props.quotes.map((quote) => (
                <div key={quote.id}>
                    <SalesDocumentRow
                        type='Quote'
                        salesDocumentTimes={getQuoteTimes(quote)}
                        actionMenuOptions={getQuoteActionMenuOptions(
                            quote.id,
                            quote.shareableViewInBrowserLink,
                            quote.slug,
                            quote.displayStatus,
                            props.handleDownloadQuote,
                            props.handleDuplicateQuote,
                            props.handleUpdateQuoteStatus,
                            props.handleSendQuoteViaEmail,
                            props.handleCreateInvoiceFromQuote
                        )}
                        modalUrl={quote.modalUrl}
                        displayNumber={quote.displayNumber}
                        price={quote.total.formattedWithCents}
                        status={quote.displayStatus}
                    />
                </div>
            ))}
        </StackLegacy>
    );
}
